import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import AppRoutes from './Route';
import Header from './Layout/Header';
import Footer from './Layout/Footer';
import ScrollToTop from './ScrollToTop';

function App() {

  return (
    <BrowserRouter>
    <div className="App">
        <ScrollToTop />
        <Header />
        <AppRoutes />
        <Footer />
    </div>
    </BrowserRouter>
  );
}

export default App;
